import * as React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import Schedule from '@material-ui/icons/Schedule';
import { SectionFieldContainerProps } from 'typings';
import useStyles from '../../styles/componentStyle';

const TimeField: React.FC<SectionFieldContainerProps> = ({ sectionFieldDetails, isMobile }) => {
  const { isMandatory, name, rank } = sectionFieldDetails;
  const labelFor = `${name}-${rank}-time`;

  const [value, setValue] = React.useState('');
  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };
  const classes = useStyles();

  return (
    <FormControl fullWidth variant='outlined' size={isMobile ? 'small' : 'medium'} required={isMandatory}>
      <InputLabel classes={{ root: classes.inputLabel }} htmlFor={labelFor}>
        {name}
      </InputLabel>
      <OutlinedInput
        id={labelFor}
        value={value}
        onChange={handleValueChange}
        label={name}
        endAdornment={<InputAdornment position='end'>{!isMobile && <Schedule />}</InputAdornment>}
      />
    </FormControl>
  );
};

export default TimeField;
